export function useMaskedEmail(email: string | null | undefined): string {
  // Verificar se o email é nulo ou undefined
  if (!email) return "--";
  if (/@/.test(email)) {
    const [username, domain] = email.split("@");
    const maskedUsername =
      username.slice(0, 3) + "*".repeat(Math.max(0, username.length - 3));
    return `${maskedUsername}@${domain}`;
  }
  return email;
}
